export class UnrestrictedEntityUpdate {
  entityId!: string;
  revision!: number;
  internalNotes!: string;
  updateUser!: string;
}
